import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const RULES_REQUEST = 'FETCH_RULES_REQUEST';
export const RULES_FAILURE = 'FETCH_RULES_FAILURE';
export const RULES_SUCCESS = 'FETCH_RULES_SUCCESS';

/**
 * @param {string} [ruleId] fetch ONE ruleset instead of all of them.
 *
 * A competition uses exactly one ruleset, and the whole collection serializes
 * to 1.9 MB against 78 KB for a single rule — measured on live data, 31
 * rulesets to reach the one a competition page needs.
 *
 * Read from the COLLECTION with `?id=`, not from the item endpoint: the item
 * GET on Rule is `ROLE_ADMIN` while the collection is `ROLE_USER`, and a
 * secretary opening a competition is neither.
 *
 * The store records WHICH rule it holds, because `isFetched` alone would tell
 * the settings screens the list is complete when it is one ruleset.
 */
export const fetchRules = (ruleId) => {
    return function(dispatch) {
        dispatch(fetchRulesRequest());
        return axios(apiRequestOptions(apiPath.RULES.LIST, ruleId ? { id: ruleId } : null))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchRulesSuccess(response.data, ruleId || null)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchRulesFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRulesRequest = () => {
    return {
        type: RULES_REQUEST,
    }
};

const fetchRulesFailure = (error) => {
    return {
        type: RULES_FAILURE,
        error,
    }
};

const fetchRulesSuccess = (data, rule) => {
    return {
        type: RULES_SUCCESS,
        data,
        // null for the unfiltered read — «these are all the rulesets».
        rule: rule || null,
    }
};